<template>
  <div id="modalDetailsEvento" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Detalhes do Evento</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div class="modal-body pb-0">
          <!-- Dados do Evento -->
          <div class="card border border-width-2 border-teal">
            <div class="card-header d-flex align-items-center p-2">
              <p class="mb-0">Dados do Evento</p>
              <div class="ms-auto">
                <p class="fs-sm mb-0">
                  <span>
                    {{
                      createdUpdatedUser(
                        evento.usuarioCriacao,
                        evento.dataCriacao,
                        'created',
                      )
                    }}
                  </span>
                  <span v-if="evento.usuarioAlteracao" class="px-1">|</span>
                  <span v-if="evento.usuarioAlteracao">
                    {{
                      createdUpdatedUser(
                        evento.usuarioAlteracao,
                        evento.dataAlteracao,
                        'updated',
                      )
                    }}
                  </span>
                </p>
              </div>
            </div>
            <div class="card-body">
              <div class="row g-2">
                <div class="col-md-6">
                  <p class="text-muted mb-1">Demandante (Gestor)</p>
                  <p class="fw-semibold mb-0">{{ evento.demandante }}</p>
                </div>
                <div class="col-md-6">
                  <p class="text-muted mb-1">Entidade Demandante</p>
                  <p class="fw-semibold mb-0">
                    {{ evento.entidadeDemandante }}
                  </p>
                </div>
                <div class="col-md-6">
                  <p class="text-muted mb-1">
                    Nome do evento, patrocínio ou projeto
                  </p>
                  <p class="fw-semibold mb-0">{{ evento.nome }}</p>
                </div>
                <div class="col-md-6">
                  <p class="text-muted mb-1">Data</p>
                  <p class="fw-semibold mb-0">
                    {{ dateTimeSqlToDateBR(evento.dataInicial) }} -
                    {{ dateTimeSqlToDateBR(evento.dataFinal) }}
                  </p>
                </div>
                <div class="col-md-6">
                  <p class="text-muted mb-1">
                    Local de realização - Cidade/Estado
                  </p>
                  <p class="fw-semibold mb-0">
                    {{ evento.local }} - {{ evento.cidade }}/{{ evento.estado }}
                  </p>
                </div>
                <div class="col-md-6">
                  <p class="text-muted mb-1">Público</p>
                  <p class="fw-semibold mb-0">
                    {{ formatWithDot(evento.publico) }}
                  </p>
                </div>
                <div class="col-md-6">
                  <p class="text-muted mb-1">Observações</p>
                  <p class="fw-semibold mb-0">
                    {{ evento.observacao ?? '-' }}
                  </p>
                </div>
                <div class="col-md-6">
                  <p class="text-muted mb-1">
                    Custo Total Cadastrado
                    <span v-if="evento.custoTotalAprovado !== null">
                      / Custo Total Aprovado
                    </span>
                  </p>
                  <p class="fw-semibold mb-0">
                    {{ moneyToCurrencyBr(evento.custoTotal) }}
                    <span v-if="evento.custoTotalAprovado !== null">
                      / {{ moneyToCurrencyBr(evento.custoTotalAprovado) }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Dados das Entidades -->
          <p class="mb-3">Entidades:</p>
          <div
            class="card border border-width-2 border-teal"
            v-for="(entidade, index) in evento.entidades"
            :key="index"
          >
            <div class="card-header d-flex align-items-center p-2">
              <p class="mb-0">
                Status atual:
                <span
                  v-html="statusEventosTranslate(entidade.status, 'label')"
                />
              </p>
              <span
                v-if="entidade.principal == entidadesEventos.PRINCIPAL"
                class="badge bg-primary ms-1"
              >
                Principal
              </span>
              <div class="ms-auto">
                <p class="fs-sm mb-0">
                  <span>
                    {{
                      createdUpdatedUser(
                        entidade.usuarioCriacao,
                        entidade.dataCriacao,
                        'created',
                      )
                    }}
                  </span>
                  <span v-if="entidade.usuarioAlteracao" class="px-1">|</span>
                  <span v-if="entidade.usuarioAlteracao">
                    {{
                      createdUpdatedUser(
                        entidade.usuarioAlteracao,
                        entidade.dataAlteracao,
                        'updated',
                      )
                    }}
                  </span>
                </p>
              </div>
            </div>
            <div class="card-body">
              <div class="row g-2">
                <div class="col-md-6">
                  <p class="text-muted mb-1">Nome</p>
                  <p class="fw-semibold mb-0">{{ entidade.nome }}</p>
                </div>
                <div class="col-md-3">
                  <p class="text-muted mb-1">Classificação</p>
                  <p class="fw-semibold mb-0">
                    {{ entidade.classificacao ?? '-' }}
                  </p>
                </div>
                <div class="col-md-3">
                  <p class="text-muted mb-1">
                    Custo Cadastrado
                    <span v-if="entidade.custoAprovado !== null">
                      / Custo Aprovado
                    </span>
                  </p>
                  <p class="fw-semibold mb-0">
                    {{ moneyToCurrencyBr(entidade.custo) }}
                    <span v-if="entidade.custoAprovado !== null">
                      / {{ moneyToCurrencyBr(entidade.custoAprovado) }}
                    </span>
                  </p>
                </div>
                <template v-if="entidade.codColigada !== null">
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Centro de Custo (Agrupador)</p>
                    <p class="fw-semibold mb-0">
                      {{ entidade.codCCustoPai || '-' }}
                      {{
                        entidade.nomeCCustoPai
                          ? `- ${entidade.nomeCCustoPai}`
                          : ''
                      }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Centro de Custo (Detalhado)</p>
                    <p class="fw-semibold mb-0">
                      {{ entidade.codCCustoFilho || '-' }}
                      {{
                        entidade.nomeCCustoFilho
                          ? `- ${entidade.nomeCCustoFilho}`
                          : ''
                      }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Natureza Orçamentária</p>
                    <p class="fw-semibold mb-0">
                      {{ entidade.codTBOrcamento || '-' }}
                      {{
                        entidade.nomeTBOrcamento
                          ? `- ${entidade.nomeTBOrcamento}`
                          : ''
                      }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Mês</p>
                    <p class="fw-semibold mb-0">
                      {{ nomeMes(entidade.mes) }}
                    </p>
                  </div>
                </template>
                <div v-if="entidade.observacao" class="col-md-12">
                  <p class="text-muted mb-1">Observações</p>
                  <p class="fw-semibold mb-0">{{ entidade.observacao }}</p>
                </div>
              </div>
            </div>
            <div class="card-footer p-0">
              <a
                :href="'#collapsible-historio-entidade-' + index"
                data-bs-toggle="collapse"
                class="collapsed link-success"
                aria-expanded="false"
                title="Histórico"
              >
                <div class="card-header d-flex align-items-center p-2">
                  <p class="mb-0">
                    <i class="ph-caret-down collapsible-indicator me-1" />
                    Histórico
                  </p>
                </div>
              </a>
              <div
                :id="'collapsible-historio-entidade-' + index"
                class="border-top collapse"
              >
                <div class="card-body">
                  <div class="d-flex align-items-stretch gap-2">
                    <div
                      v-for="(historico, hIndex) in entidade.historico"
                      :key="historico.id"
                      class="d-flex align-items-center gap-2"
                    >
                      <div
                        class="d-flex flex-column align-items-center h-100 gap-2 border rounded p-2"
                      >
                        <span
                          v-html="
                            statusEventosTranslate(historico.status, 'label')
                          "
                        />
                        <span class="fw-semibold fs-sm">
                          {{ historico.usuario }} ·
                          {{ dateTimeSqlToDateTimeBR(historico.data) }}
                        </span>
                        <span
                          v-if="historico.observacao"
                          class="text-muted fs-sm"
                        >
                          {{ historico.observacao }}
                        </span>
                      </div>
                      <i
                        v-if="hIndex < entidade.historico.length - 1"
                        class="ph-arrow-right text-muted"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-top-0 pt-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateTimeSqlToDateTimeBR, dateTimeSqlToDateBR } from '@/utils/date'
import {
  createdUpdatedUser,
  moneyToCurrencyBr,
  formatWithDot,
  statusEventosTranslate,
} from '@/utils/strings'
import { showModal } from '@/utils/modal'
import EntidadeEventoEnum from '@/enum/entidadeEventoEnum'

export default {
  name: 'DetailsEventoModal',

  props: {
    eventoId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      evento: {},
      meses: [
        { valor: 1, nome: 'Janeiro' },
        { valor: 2, nome: 'Fevereiro' },
        { valor: 3, nome: 'Março' },
        { valor: 4, nome: 'Abril' },
        { valor: 5, nome: 'Maio' },
        { valor: 6, nome: 'Junho' },
        { valor: 7, nome: 'Julho' },
        { valor: 8, nome: 'Agosto' },
        { valor: 9, nome: 'Setembro' },
        { valor: 10, nome: 'Outubro' },
        { valor: 11, nome: 'Novembro' },
        { valor: 12, nome: 'Dezembro' },
      ],
      dateTimeSqlToDateTimeBR,
      dateTimeSqlToDateBR,
      createdUpdatedUser,
      moneyToCurrencyBr,
      formatWithDot,
      statusEventosTranslate,
    }
  },

  computed: {
    entidadesEventos() {
      return EntidadeEventoEnum
    },
  },

  methods: {
    async getEvento() {
      try {
        this.evento = await this.$store.dispatch('getEvento', this.eventoId)
        showModal('modalDetailsEvento')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    nomeMes(numero) {
      const mes = this.meses.find((m) => m.valor === Number(numero))
      return mes ? mes.nome : '-'
    },
  },

  mounted() {
    this.getEvento()
  },
}
</script>
